import { useRef, useState } from 'react';
import Main from '../../../component/Main';
import Loading from '../../../component/common/loading/Loading';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect';
import FidelityExcelDownload from './FidelityExcelDownload';
import { SendStatMonthlyGrid } from './SendStatMonthly2016';
import { InfoMngStatMonthlyGrid } from './InfoMngStatMonthly';
import FidelityMgmtMsg from './FidelityMgmtMsg';
import useModalStore from '../../../zustand/store/useModalStore';

import '../../../css/data-grid.css';
import { useDynamicStyle } from '../../../hooks/useDynamicStyle';
import { Search16w } from '../../../images/icons/icons_component';

const Send_stat_motiroting_2016 = () => {

    const userAuth = localStorage.getItem('userAuth');

    const today = new Date();
    const currentYear = today.getFullYear();
    let currentMonth = today.getMonth() + 1;
    if (currentMonth < 10) {
        currentMonth = '0' + currentMonth;
    }

    const [searchParams, setSearchParams] = useState({
        searchYear: currentYear,
        searchMonth: currentMonth,
        searchEmog: userAuth === 'J003' ? localStorage.getItem('useremcd') : '',
        searchGrdc: userAuth === 'J003' ? localStorage.getItem('emoggrdc2') : '',
        searchLoca: userAuth === 'J003' ? localStorage.getItem('emogloca') : '',
        searchType: '01',
        fromindt: currentYear + '' + currentMonth + '01',
        toindt: currentYear + '' + currentMonth + '31'
    });

    const [isSearched, setIsSearched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // 엑셀 파일명을 '조회 시점' 기준으로 고정하기 위한 state
    const [excelInfo, setExcelInfo] = useState({ emogdesc: '', yyyymm: '' });

    // 각 영역 조회 실행용 ref
    const sendGridRef = useRef(null);
    const mngGridRef = useRef(null);
    const mgmtMsgRef = useRef(null);

    // 엑셀 다운로드 대상 ref
    const tableRef = useRef(null);

    // 검색 조건 onChange
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        if (name === 'searchYear' || name === 'searchMonth') {
            const year = name === 'searchYear' ? value : searchParams.searchYear;
            const month = name === 'searchMonth' ? value : searchParams.searchMonth;
            newParams.fromindt = `${year}${month}01`;
            newParams.toindt = `${year}${month}31`;
        }
        setSearchParams(newParams);
    };

    // toast modal open function
    const showNotiModal = useModalStore(state => state.showNotiModal);

    const search = async () => {
        if (searchParams.searchEmog === '') {
            showNotiModal('먼저 해당 응급의료기관을 선택하십시오.');
            return;
        }

        setIsLoading(true);
        try {
            await Promise.all([
                sendGridRef.current?.search(),
                mngGridRef.current?.search(),
                mgmtMsgRef.current?.search()
            ]);
        } finally {
            setIsLoading(false);
        }
    };

    // Dynamic Style Hook
    const { primaryBackColor } = useDynamicStyle();

    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width='10%' />
                        <col width='20%' />
                        <col width='10%' />
                        <col width='20%' />
                        <col width='10%' />
                        <col width='20%' />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                exValidation={true}
                            />
                        </tr>
                        <tr>
                            <th>내원기간</th>
                            <td>
                                <select id='searchYear'
                                    name='searchYear'
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 10 }, (_, i) => {
                                        const year = (currentYear - i).toString()
                                        return (
                                            <option key={year} value={year}>
                                                {year} 년
                                            </option>
                                        );
                                    })}
                                </select>
                                &ensp;
                                <select id='searchMonth'
                                    name='searchMonth'
                                    value={searchParams.searchMonth}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 12 }, (_, i) => {
                                        const month = (i + 1).toString().padStart(2, '0');
                                        return (
                                            <option key={month} value={month}>
                                                {month} 월
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                            <th>기관구분</th>
                            <td colSpan='2'>
                                <select id='searchType'
                                    name='searchType'
                                    value={searchParams.searchType}
                                    onChange={handleInputChange}
                                >
                                    <option value='01'>센터형</option>
                                    <option value='02'>기관형</option>
                                </select>
                                <span className='co_red ml-2'>* 표출되는 항목에 영향을 줍니다.</span>
                            </td>
                            <td>
                                <div className='flex gap-1 justify-end'>
                                    <button onClick={search} disabled={isLoading ? 'disabled' : ''} className={`search_btn ${primaryBackColor}`}><Search16w />검색</button>
                                    <FidelityExcelDownload
                                        targetRef={tableRef}
                                        disabled={!(isSearched && !isLoading)}
                                        excelFileName={`Nedis 월별 모니터링 결과_${excelInfo.emogdesc}_${excelInfo.yyyymm}`}
                                        colWidths={[7, 17, 17, 30, 30, 30, 30, 30, 30]}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {isLoading && <Loading />}
            <div ref={tableRef} className={isLoading ? 'hidden' : 'overflow-auto mt-5 pb-5'}>
                {/* 월별 전송내역 */}
                <SendStatMonthlyGrid
                    ref={sendGridRef}
                    searchParams={searchParams}
                    onSearched={() => setIsSearched(true)}
                />
                {/* 월별 정보관리 내역 */}
                <InfoMngStatMonthlyGrid
                    ref={mngGridRef}
                    searchParams={searchParams}
                    onSearched={({ emogdesc, yyyymm }) => setExcelInfo({ emogdesc, yyyymm })}
                />
                {/* 정보관리 요청내역(댓글) */}
                <FidelityMgmtMsg
                    ref={mgmtMsgRef}
                    searchParams={searchParams}
                />
            </div>
        </Main>
    )
}

export default Send_stat_motiroting_2016;
